// SERVER URL & STORAGE
export const BASE_URL = "https://arbiter.tibo.tv/api";
export const USERNAME = process.env.REACT_APP_USERNAME

// ENDPOINTS - auth
export const SIGN_IN = "/auth/signin";
export const SIGN_UP = "/api/v1/auth/signup";
export const FORGET_PASSWORD = "/api/v1/auth/forgot-password";
export const USER_LOGGED_IN = "/api/v1/auth/me";
export const LOGOUT = "/api/v1/auth/logout";
